import React from "react";
import styles from "../About_Us/Aboutus.module.css";

const AboutUs = () => {
  return (
    <div
      className={`container ${styles.aboutcontainerabc}  mb-4`}
      id="ABOUT_SECTION"
    >


      <div className="row justify-content-center">
        <div className="col-12">
          <div className={styles.servicesSection}>
            <div className={` ${styles.customCol}`}>
              <h2 className={`${styles.title} mb-4`}>
                <i className={`fa-solid fa-users ${styles.icontitle}`}></i> About Us
              </h2>
            </div>
            {/* Header Section */}
            <div className={styles.headerSection}>
              <p className={styles.subtitle}>
                Empowering Businesses with Efficient Management Solutions
              </p>
            </div>

            <div className="row align-items-center mt-5">
              {/* Text Section */}
              <div className="col-lg-6">
                <div className={styles.textSection}>
                  <p className={styles.aboutdescription}>
                    Welcome to our versatile Management Software, your ultimate solution for efficiently managing various types of businesses. Whether you own a Kirana shop, a retail store, or any other business, our software is designed to meet your needs. With features that simplify inventory tracking, streamline billing, and enhance customer management, we empower business owners to save time, reduce errors, and focus on growth. No matter the size or type of your business, our tools are here to help you achieve success effortlessly.
                  </p>
                  <p className={styles.aboutdescription}>
                    Managing multiple stores can be a complex task, but our Kirana Management Software makes it seamless and efficient. Whether you have two locations or more, you can now centralize operations and have complete control over your business. Let us be your partner in achieving success.
                  </p>
                  <p className={styles.aboutdetails}>
                    Let’s build a better future for your business, together.
                  </p>
                </div>
              </div>

              {/* Image Section */}
              <div className="col-lg-6 d-flex justify-content-center align-items-center ">
                <div className={styles.imageSection}>
                  <img
                    src="/images/landing2.png"
                    alt="About Us"
                    className={styles.aboutImage}
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
